import { render, staticRenderFns } from "./FindPassword.vue?vue&type=template&id=a3144b44&"
import script from "./FindPassword.vue?vue&type=script&lang=ts&"
export * from "./FindPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports